<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Detalhes da Conta Corrente</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto"></div>
        </div>
      </div>
      <d-row>
        <!-- Cards -->
        <d-col
          v-for="(card, index) in Cards"
          :key="index"
          md="4"
          lg="4"
          class="mb-4"
        >
          <cards
            :id="`card-${index}`"
            :label="card.label"
            :link="card.link"
            :title="card.title"
            :small="true"
            :value="card.value"
          />
        </d-col>
      </d-row>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col" lg="2" style="max-width: 250px">
          <div class="list-group dados-list">
            <a
              class="list-group-item active"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('T')"
            >
              <i class="item-icon fas fa-tag"></i>
              <span class="item-title">Todos</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('B')"
            >
              <i class="item-icon fas fa-barcode"></i>
              <span class="item-title">Boleto</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('C')"
            >
              <i class="item-icon fas fa-credit-card"></i>
              <span class="item-title">Cartão de Crédito</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('CR')"
            >
              <i class="item-icon fab fa-bitcoin"></i>
              <span class="item-title">Criptomoeda</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('D')"
            >
              <i class="item-icon fas fa-credit-card"></i>
              <span class="item-title">Cartão de Débito</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('P')"
            >
              <i class="item-icon fas fa-coins"></i>
              <span class="item-title">Pix</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('CI')"
            >
              <i class="item-icon fas fa-project-diagram"></i>
              <span class="item-title">Cielo</span>
              <span v-show="cielo && this.infoDetails.AmountNetCielo > 0"><br /> {{
                this.$options.filters.currency(this.infoDetails.AmountNetCielo)
              }}</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('S')"
            >
              <i class="item-icon fas fa-university"></i>
              <span class="item-title">Santander</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('BB')"
            >
              <i class="item-icon fas fa-university"></i>
              <span class="item-title">Banco do Brasil</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('SI')"
            >
              <i class="item-icon fas fa-university"></i>
              <span class="item-title">Sicredi</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('O')"
            >
              <i class="item-icon fas fa-money-check-alt"></i>
              <span class="item-title">Outros</span>
            </a>
          </div>
        </div>
        <div class="col" lg="10">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <b-row align-h="between">
                <b-col cols="6">
                  <button
                    class="btn button-arrow"
                    type="button"
                    v-on:click="AlterDay(true)"
                    title="Dia anterior"
                  >
                    <i class="fas fa-chevron-left"></i>
                  </button>
                </b-col>
                <b-col cols="6" class="d-flex justify-content-end">
                  <div>
                    <button
                      class="btn text-right button-arrow-right"
                      style="width: 40px"
                      type="button"
                      title="Próximo dia"
                      v-on:click="AlterDay(false)"
                    >
                      <i class="fas fa-chevron-right"></i>
                    </button>
                  </div>
                </b-col>
              </b-row>
              <b-row align-h="between" class="mt-3">
                <b-col cols="6">
                  <h6 class="m-0">Recebimentos</h6>
                </b-col>
                <b-col cols="6" class="d-flex justify-content-end">
                  <b-input-group
                    class="d-flex justify-content-end my-auto ml-2"
                  >
                    <h6 v-if="pagination.TotalItems > 0" class="m-0">
                      {{ pagination.TotalItems | number }}
                      {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                    </h6>
                    <div class="dropdown m-0" v-if="pagination.TotalItems > 1">
                      <button
                        class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                        type="button"
                        v-b-tooltip.hover.right
                        title="Mais opções"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="fas fa-ellipsis-v"></i>
                      </button>
                      <div
                        class="dropdown-menu"
                        id="dropTableOptions"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a
                          class="dropdown-item"
                          href="#"
                          :class="loadingReport ? 'disabled' : ''"
                          v-on:click.stop="GetReport($event)"
                        >
                          <template v-if="loadingReport">
                            <loader
                              :small="true"
                              :isLoading="loadingReport"
                            ></loader>
                          </template>
                          <template v-else>
                            <i class="fas fa-check mr-2"></i>
                            Gerar relatório
                          </template>
                        </a>
                      </div>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      TID / Transação
                    </th>
                    <th scope="col" class="border-0">
                      Valor líquido / Valor bruto
                    </th>
                    <th scope="col" class="border-0">Parcela</th>
                    <th scope="col" class="border-0">Aceleração</th>
                    <th scope="col" class="border-0">Bandeira / MCC</th>

                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(checkingAccount, index) in checkingAccounts"
                    :key="index"
                  >
                    <td></td>
                    <td class="text-left td-with-subs">
                      <div
                        v-if="
                          checkingAccount.Tid != '' &&
                          checkingAccount.Tid != undefined
                        "
                      >
                        {{ checkingAccount.Tid }}
                      </div>
                      <div v-else>Não informado</div>

                      <span
                        class="td-span-style"
                        v-if="checkingAccount.IdTransaction > 0"
                        >{{ checkingAccount.IdTransaction }}</span
                      >
                      <span class="td-span-style" v-else> Não localizado</span>
                    </td>
                    <td class="text-center td-with-subs">
                      <div>
                        {{ checkingAccount.AmountInstallmentNet | currency }}
                      </div>
                      <span class="td-span-style">{{
                        checkingAccount.AmountInstallment | currency
                      }}</span>
                    </td>

                    <td>{{ checkingAccount.InstallmentNumber }}</td>
                    <td v-if="checkingAccount.IsAdvancement">
                      <i class="fas fa-check fa-success"></i>
                    </td>
                    <td v-else>
                      <i class="fas fa-minus"></i>
                    </td>
                    <td class="text-center td-with-subs">
                      <div>{{ checkingAccount.NameBrand }}</div>
                      <span class="td-span-style">{{
                        checkingAccount.CodeMcc
                      }}</span>
                    </td>

                    <td></td>
                  </tr>
                  <tr
                    v-if="
                      checkingAccounts == undefined ||
                      checkingAccounts == null ||
                      checkingAccounts.length == 0
                    "
                  >
                    <td colspan="10">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a
      href="#"
      class="btn-float btn-primary"
      v-show="showBtnScroll"
      v-on:click="ScrollToTop($event)"
    >
      <i class="fa fa-chevron-up"></i>
    </a>
  </div>
</template>

<script>
import cards from "@/components/common/cards";
export default {
  name: "checking-account-details",
  data: function () {
    return {
      checkingAccounts: [],
      filter: {
        CodePaymentMethod: null,
        InitialDate: this.$route.query.initialDate,
        TypeFilter: "T",
      },
      infoDetails: {
        Amount: 0,
        Tax: 0,
        AmountAdvancePayment: 0,
        AmountReprocessed: 0,
      },
      loadingList: false,
      loadingReport: false,
      cielo: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
      showBtnScroll: false,
    };
  },
  components: {
    cards,
  },
  computed: {
    Cards() {
      return [
        {
          label: "Dia",
          value: this.$options.filters.date(this.filter.InitialDate),
          link: {
            component: "checking-account",
          },
          title: "Clique para alterar a data",
        },
        {
          label: "Total de esperado",
          value: this.$options.filters.currency(this.infoDetails.Amount),
        },
        {
          label: "Total efetivado",
          value: this.$options.filters.currency(this.infoDetails.AmountPayment),
        },
        {
          label: "Total de custo",
          value: this.$options.filters.currency(this.infoDetails.Tax),
        },
        {
          label: "Total antecipado",
          value: this.$options.filters.currency(
            this.infoDetails.AmountAdvancePayment
          ),
        },
        {
          label: "Total remanejado",
          value: this.$options.filters.currency(
            this.infoDetails.AmountReprocessed
          ),
        },
        // {
        //   label: "Total Cielo",
        //   value: this.$options.filters.currency(
        //     this.infoDetails.AmountNetCielo
        //   ),
        // },
      ];
    },
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListPeriod();
    },
    "pagination.RowsPerPage": function () {
      this.ListPeriod();
    },
  },
  created() {
    window.addEventListener("scroll", this.HandleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.HandleScroll);
  },
  mounted() {
    this.ListPeriod();
  },
  methods: {
    HandleScroll: function () {
      if (
        document.body.scrollTop > 120 ||
        document.documentElement.scrollTop > 120
      ) {
        this.showBtnScroll = true;
      } else {
        this.showBtnScroll = false;
      }
    },
    ScrollToTop: function () {
      window.scrollTo(0, 0);
    },
    FilterPaymentMethod: function (code) {
      this.filter.TypeFilter = code;

      if (code == "CI") {
        this.cielo = true;
      } else this.cielo = false;
      this.ListPeriod();
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      const params = {
        "Object.ReleaseDate": this.filter.InitialDate,
        TypeFilter: this.filter.TypeFilter,
      };
      this.$store
        .dispatch("ListAcquirerReceivables", { params: params })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    AlterDay: function (prev) {
      let date = new Date(this.filter.InitialDate);
      this.filter.InitialDate = prev
        ? this.$options.filters.addDay(date, -1)
        : this.$options.filters.addDay(date, 1);
      this.ListPeriod();
    },
    ListPeriod: function () {
      this.ResetInfoDetails();
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.ReleaseDate": this.filter.InitialDate,
          "Object.TypeGroup": this.filter.TypeFilter,
        },
      };
      this.$store
        .dispatch("ListAcquirerReceivables", { params: data })
        .then((response) => {
          this.infoDetails = response;
          this.checkingAccounts = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar os detalhes da conta corrente",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ResetInfoDetails: function () {
      this.infoDetails = {
        Amount: 0,
        Tax: 0,
        AmountAdvancePayment: 0,
        AmountReprocessed: 0,
        CheckingAccounts: [],
      };
    },
  },
};
</script>

<style scoped>
.item-icon {
  font-size: 17px;
}
.item-title {
  margin-left: 10px;
}
.td-span-style {
  font-size: 9pt;
  opacity: 0.75;
}
.dados-list > .active {
  color: white;
}
.dados-list > .list-group-item:hover {
  background: #00304df0;
  color: white;
}
.fa-danger {
  color: #ff0000;
}

.fa-warning {
  color: #e6a200;
}

.fa-secondary {
  color: #00a2bf;
}

.fa-success {
  color: #09ab6f;
}
</style>
<style scoped>
.td-span-style {
  font-size: 10pt;
  opacity: 0.75;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/checkingAccountDetails.vue